<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addStudentModal"
              v-if="this.students.length > 0 && hasPermission('codes')"
            >
              <i class="fas fa-plus ms-1"></i>
              أضف محتوى لطلاب الفصل
            </button>

            <!-- Add Modal Start -->
            <div
              class="modal fade"
              id="addStudentModal"
              tabindex="-1"
              aria-labelledby="addStudentModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضف محتوى</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form @submit.prevent="addContentToStudents($event)">
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="numberofviews">مرات المشاهدة</label>
                            <input
                              class="form-control"
                              type="number"
                              placeholder="عدد مرات المشاهدة"
                              v-model="code.number_of_views"
                              id="numberofviews"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="numberofviews">تاريخ الانتهاء</label>
                            <input
                              class="form-control"
                              type="datetime-local"
                              placeholder="تاريخ الانتهاء"
                              v-model="code.expired_date"
                              :min="today"
                              id="numberofviews"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-12">
                          <!-- Content type -->
                          <div class="col-12">
                            <div class="form-group">
                              <label>نوع المحتوى</label>
                              <select
                                class="form-control form-select"
                                aria-label="Default select"
                                v-model="contentType"
                                required
                              >
                                <option selected disabled :value="0">
                                  اختيار نوع المحتوى
                                </option>
                                <option :value="1">درس</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>التصنيف</label>
                            <select
                              class="form-select form-control mt-2"
                              aria-label="Default select "
                              id="mainCate"
                              required
                              @change="
                                onSelectMainCategory($event.target.value)
                              "
                            >
                              <option selected disabled :value="0">
                                اختار التصنيف
                              </option>
                              <option
                                v-for="category in this.Maincategories"
                                :key="category.category_id"
                                :value="category.title"
                              >
                                {{ category.title }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <!-- Sub Category -->
                        <Transition name="scale" mode="out-in">
                          <div class="col-12 col-md-6">
                            <div
                              class="form-group"
                              v-if="this.subSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subCategory"
                                @change="
                                  onSelectSubCategory($event.target.value)
                                "
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </Transition>
                        <!-- Sub Sub Category -->
                        <Transition name="scale" mode="out-in">
                          <div class="col-12 col-md-6">
                            <div
                              class="form-group"
                              v-if="this.subSubSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                @change="
                                  onSelectSubSubCategory($event.target.value)
                                "
                              >
                                <option selected disabled value="">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </Transition>
                        <!-- Sub Sub Sub Category -->
                        <Transition name="scale" mode="out-in">
                          <div class="col-12 col-md-6">
                            <div
                              class="form-group"
                              v-if="this.subSubSubSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                @change="
                                  onSelectSubSubSubCategory($event.target.value)
                                "
                              >
                                <option selected disabled value="">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubSubSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </Transition>
                        <!-- Add Lesson -->
                        <Transition name="scale" mode="out-in">
                          <div class="col-12" v-if="contentType === 1">
                            <div class="form-group">
                              <label>الدروس</label>

                              <select
                                v-if="lessonsList.length > 0"
                                class="form-control form-select"
                                aria-label="Default select"
                                required
                                @change="onSelectLesson($event.target.value)"
                              >
                                <option selected :value="0">
                                  اختيار الدرس
                                </option>
                                <option
                                  v-for="(lesson, index) in this.lessonsList"
                                  :key="index"
                                  :value="index"
                                >
                                  {{ lesson.title }}
                                </option>
                              </select>
                              <div v-else class="text-center">
                                <span>لا يوجد دروس حتى الان</span>
                              </div>
                            </div>
                          </div>
                        </Transition>
                        <!-- if Lesson have Videos -->
                        <Transition name="scale" mode="out-in">
                          <div class="col-12" v-if="this.videosList.length > 0">
                            <div class="form-group">
                              <label>محتوى الدرس (اختيارى)</label>
                              <select
                                v-if="this.videosList.length > 0"
                                class="form-control form-select"
                                aria-label="Default select"
                                @change="onSelectContent($event.target.value)"
                              >
                                <option selected :value="0">
                                  اختيار محتوى معين داخل الدرس
                                </option>
                                <option
                                  v-for="(video, index) in this.videosList"
                                  :key="index"
                                  :value="index"
                                >
                                  {{ video.title }}
                                </option>
                              </select>
                              <div v-else class="text-center">
                                <span>لا يوجد محتوى للدروس حتى الان</span>
                              </div>
                            </div>
                          </div>
                        </Transition>
                        <!--  -->
                        <!--  -->
                        <!--  -->
                        <!--  -->
                        <!--  -->
                        <!--  -->
                        <!--  -->
                        <!--  -->

                        <!-- Buttons -->
                        <div class="col-12">
                          <div class="form-group text-start mt-4">
                            <button type="submit" class="btn w-100 add">
                              أضافة
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Modal End -->
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <Transition name="scale" mode="out-in">
            <div class="table__select" v-if="this.checkedStudents.length > 0">
              <div class="table__select__count">
                تم تحديد {{ this.checkedStudents.length }}
              </div>
              <div class="table__select__buttons">
                <button
                  class="btn add"
                  data-bs-toggle="modal"
                  data-bs-target="#addContentToSelectedStudentModal"
                  v-if="this.students.length > 0"
                >
                  <i class="fas fa-plus ms-1"></i>
                  أضف محتوى للطلاب المحدده
                </button>

                <!-- Add Modal Start -->
                <div
                  class="modal fade"
                  id="addContentToSelectedStudentModal"
                  tabindex="-1"
                  aria-labelledby="addContentToSelectedStudentModalLabel"
                  aria-hidden="true"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">أضف محتوى</h5>
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          @click="clearData()"
                        ></button>
                      </div>
                      <div class="modal-body">
                        <form
                          @submit.prevent="addContentToSelectedStudents($event)"
                        >
                          <div class="row">
                            <div class="col-12 col-md-6">
                              <div class="form-group">
                                <label for="numberofviews">مرات المشاهدة</label>
                                <input
                                  class="form-control"
                                  type="number"
                                  placeholder="عدد مرات المشاهدة"
                                  v-model="code.number_of_views"
                                  id="numberofviews"
                                />
                              </div>
                            </div>
                            <div class="col-12 col-md-6">
                              <div class="form-group">
                                <label for="numberofviews"
                                  >تاريخ الانتهاء</label
                                >
                                <input
                                  class="form-control"
                                  type="datetime-local"
                                  placeholder="تاريخ الانتهاء"
                                  v-model="code.expired_date"
                                  :min="today"
                                  id="numberofviews"
                                />
                              </div>
                            </div>
                            <div class="col-12">
                              <!-- Content type -->
                              <div class="col-12">
                                <div class="form-group">
                                  <label>نوع المحتوى</label>
                                  <select
                                    class="form-control form-select"
                                    aria-label="Default select"
                                    v-model="contentType"
                                  >
                                    <option selected disabled :value="0">
                                      اختيار نوع المحتوى
                                    </option>
                                    <option :value="1">درس</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-md-6">
                              <div class="form-group">
                                <label>التصنيف</label>
                                <select
                                  class="form-select form-control mt-2"
                                  aria-label="Default select "
                                  id="mainCate"
                                  @change="
                                    onSelectMainCategory($event.target.value)
                                  "
                                >
                                  <option selected disabled :value="0">
                                    اختار التصنيف
                                  </option>
                                  <option
                                    v-for="category in this.Maincategories"
                                    :key="category.category_id"
                                    :value="category.title"
                                  >
                                    {{ category.title }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <!-- Sub Category -->
                            <Transition name="scale" mode="out-in">
                              <div class="col-12 col-md-6">
                                <div
                                  class="form-group"
                                  v-if="this.subSelect.length > 0"
                                >
                                  <label>تصنيف فرعى</label>
                                  <select
                                    class="form-select form-control mt-2"
                                    aria-label="Default select "
                                    id="subCategory"
                                    @change="
                                      onSelectSubCategory($event.target.value)
                                    "
                                  >
                                    <option selected disabled :value="0">
                                      اختار التصنيف
                                    </option>
                                    <option
                                      v-for="category in this.subSelect"
                                      :key="category.category_id"
                                      :value="category.title"
                                    >
                                      {{ category.title }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </Transition>
                            <!-- Sub Sub Category -->
                            <Transition name="scale" mode="out-in">
                              <div class="col-12 col-md-6">
                                <div
                                  class="form-group"
                                  v-if="this.subSubSelect.length > 0"
                                >
                                  <label>تصنيف فرعى</label>
                                  <select
                                    class="form-select form-control mt-2"
                                    aria-label="Default select "
                                    @change="
                                      onSelectSubSubCategory(
                                        $event.target.value
                                      )
                                    "
                                  >
                                    <option selected disabled value="">
                                      اختار التصنيف
                                    </option>
                                    <option
                                      v-for="category in this.subSubSelect"
                                      :key="category.category_id"
                                      :value="category.title"
                                    >
                                      {{ category.title }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </Transition>
                            <!-- Sub Sub Sub Category -->
                            <Transition name="scale" mode="out-in">
                              <div class="col-12 col-md-6">
                                <div
                                  class="form-group"
                                  v-if="this.subSubSubSelect.length > 0"
                                >
                                  <label>تصنيف فرعى</label>
                                  <select
                                    class="form-select form-control mt-2"
                                    aria-label="Default select "
                                    @change="
                                      onSelectSubSubSubCategory(
                                        $event.target.value
                                      )
                                    "
                                  >
                                    <option selected disabled value="">
                                      اختار التصنيف
                                    </option>
                                    <option
                                      v-for="category in this.subSubSubSelect"
                                      :key="category.category_id"
                                      :value="category.title"
                                    >
                                      {{ category.title }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </Transition>
                            <!-- Add Lesson -->
                            <Transition name="scale" mode="out-in">
                              <div class="col-12" v-if="contentType === 1">
                                <div class="form-group">
                                  <label>الدروس</label>

                                  <select
                                    v-if="lessonsList.length > 0"
                                    class="form-control form-select"
                                    aria-label="Default select"
                                    required
                                    @change="
                                      onSelectLesson($event.target.value)
                                    "
                                  >
                                    <option selected :value="0">
                                      اختيار الدرس
                                    </option>
                                    <option
                                      v-for="(lesson, index) in this
                                        .lessonsList"
                                      :key="index"
                                      :value="index"
                                    >
                                      {{ lesson.title }}
                                    </option>
                                  </select>
                                  <div v-else class="text-center">
                                    <span>لا يوجد دروس حتى الان</span>
                                  </div>
                                </div>
                              </div>
                            </Transition>
                            <!-- if Lesson have Videos -->
                            <Transition name="scale" mode="out-in">
                              <div
                                class="col-12"
                                v-if="this.videosList.length > 0"
                              >
                                <div class="form-group">
                                  <label>محتوى الدرس (اختيارى)</label>
                                  <select
                                    v-if="this.videosList.length > 0"
                                    class="form-control form-select"
                                    aria-label="Default select"
                                    @change="
                                      onSelectContent($event.target.value)
                                    "
                                  >
                                    <option selected :value="0">
                                      اختيار محتوى معين داخل الدرس
                                    </option>
                                    <option
                                      v-for="(video, index) in this.videosList"
                                      :key="index"
                                      :value="index"
                                    >
                                      {{ video.title }}
                                    </option>
                                  </select>
                                  <div v-else class="text-center">
                                    <span>لا يوجد محتوى للدروس حتى الان</span>
                                  </div>
                                </div>
                              </div>
                            </Transition>
                            <!--  -->
                            <!--  -->
                            <!--  -->
                            <!--  -->
                            <!--  -->
                            <!--  -->
                            <!--  -->
                            <!--  -->

                            <!-- Buttons -->
                            <div class="col-12">
                              <div class="form-group text-start mt-4">
                                <button type="submit" class="btn w-100 add">
                                  أضافة
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Add Modal End -->

                <button
                  class="btn edit"
                  data-bs-toggle="modal"
                  data-bs-target="#moveStudentsToModal"
                >
                  <i class="fas fa-plus ms-1"></i>
                  نقل الطلاب الى الفصل اخر
                </button>
                <!-- Add Modal Start -->
                <div
                  class="modal fade"
                  id="moveStudentsToModal"
                  tabindex="-1"
                  aria-labelledby="moveStudentsToModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">نقل الى</h5>
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          @click="this.clearData()"
                        ></button>
                      </div>
                      <div class="modal-body">
                        <form @submit.prevent="moveStudentsToNewClass($event)">
                          <div class="row">
                            <!-- className -->
                            <div class="col-12">
                              <div class="form-group">
                                <label for="classAdded">الفصول</label>
                                <select
                                  class="form-control form-select"
                                  aria-label="Default select"
                                  id="classAdded"
                                  v-model="newClass"
                                  required
                                >
                                  <option
                                    v-for="(onceClass, index) in this.classes"
                                    :key="index"
                                    :value="onceClass.class_id"
                                  >
                                    {{ onceClass.title }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <!-- Buttons -->
                            <div class="col-12">
                              <div class="form-group text-start mt-4">
                                <button type="submit" class="btn w-100 add">
                                  أضافة
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Add Modal Start -->

                <button class="btn delete" @click="deleteMultiStudentSelect()">
                  <i class="fas fa-trash-alt ms-2"></i>
                  حذف
                </button>
              </div>
            </div>
          </Transition>
          <div v-show="!this.isloading" class="table-responsive">
            <table
              v-show="this.students.length > 0"
              class="table table-striped"
            >
              <thead>
                <tr>
                  <th class="text-center" style="width: 5%" scope="col">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="allSelected"
                      @change="selectAll"
                    />
                  </th>

                  <th class="fit" scope="col">الرقم</th>
                  <th scope="col">اسم طالب</th>
                  <th scope="col">رقم الطالب</th>
                  <th scope="col">الصف الدراسي</th>
                  <th scope="col">الفصول</th>
                  <th scope="col">تحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(student, index) in this.students" :key="index">
                  <th class="text-center" scope="row">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                      v-model="checkedStudents"
                      @change="updateCheckall()"
                      :value="student"
                    />
                  </th>
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ student.name }}</td>
                  <td>{{ student.phone }}</td>
                  <td>{{ student.grade.title }}</td>
                  <td>
                    <div>
                      <ul class="mb-0 pe-0">
                        <li
                          v-for="(className, index) in student.fullClassesInfo"
                          :key="index"
                        >
                          - {{ className.title }}
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td>
                    <button
                      class="btn me-2 delete"
                      @click="deleteSelectedStudent(student, index)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              v-show="
                (!this.isloading && !this.students) || this.students.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">
                لا يوجد طلاب فى هذا الفصل حتى الآن
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      today: new Date().toISOString().substr(0, 10),

      contentType: 1,
      // Loading
      isloading: true,
      // Lessons
      lessons: [],
      lessonsList: [],
      // class id
      classId: this.$route.params.id,
      classes: [],
      students: [],
      studentsIds: [],
      currentView: "طلاب الفصل",
      //
      lessonSelect: {
        contents: [],
      },
      code: {
        content_id: "",
        number_of_views: 3,
        expired_date: "",
        fullInfo: {},
      },

      // Select
      allSelected: false,
      checkedStudents: [],
      //
      newClass: "",

      // Select Lessons by Grade
      grades: [],
      // Category
      categories: [],
      selectedCategoryIDs: [],
      Maincategories: [],
      subSelect: [],
      subSubSelect: [],
      subSubSubSelect: [],
      videosList: [],
    };
  },
  methods: {
    ...mapActions("classesModule", [
      "getSubCollectionIds",
      "getStudents",
      "decreaseCount",
      "deleteStudentFromClass",
      // On Select
      "removeMultiStudentsFromClass",
      "removeMultiClassesFromStudents",
      "decreaseMultiStudents",
      "increaseMultiStudents",
      "addStudentToNewClass",
    ]),

    ...mapActions("lessonsModule", ["fetchLessons"]),
    ...mapActions("studentsModule", [
      "updateStudent",
      "addContentToStudentsClass",
      "addClassToStudents",
    ]),
    //
    //
    //
    //
    //

    onSelectMainCategory(e) {
      let title = e;
      let selectedCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      this.selectedCategoryIDs = [];
      this.subSelect = [];
      this.subSubSelect = [];
      this.selectedCategoryIDs.push(selectedCategory.category_id);

      this.lessonsList = this.getLessons.filter(
        (lesson) => lesson.categories[0] == this.selectedCategoryIDs[0]
      );
      if (selectedCategory.sub_categories.length > 0) {
        this.subSelect.push(...selectedCategory.sub_categories);
      }
      this.videosList = [];
      document.getElementById("subCategory").value = 0;
    },
    // Sub Cateory
    onSelectSubCategory(e) {
      let title = e;
      let selectedSubCategory = this.subSelect.filter(
        (item) => item.title === title
      )[0];
      this.selectedCategoryIDs.splice(2, 1);
      this.lessonsList = [];
      this.selectedCategoryIDs[1] = selectedSubCategory.category_id;
      this.getLessons.forEach((lesson) => {
        if (
          lesson.categories[0] == this.selectedCategoryIDs[0] &&
          lesson.categories[1] == this.selectedCategoryIDs[1]
        )
          this.lessonsList.push(lesson);
      });

      this.subSubSelect = [];
      if (selectedSubCategory.sub_categories.length > 0) {
        this.subSubSelect.push(...selectedSubCategory.sub_categories);
      }
    },
    // Sub Sub Cateory
    onSelectSubSubCategory(e) {
      let title = e;
      let selectedSubSubCategory = this.subSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.selectedCategoryIDs[2] = selectedSubSubCategory.category_id;
      this.lessonsList = [];
      this.getLessons.forEach((lesson) => {
        if (
          lesson.categories[0] == this.selectedCategoryIDs[0] &&
          lesson.categories[1] == this.selectedCategoryIDs[1] &&
          lesson.categories[2] == this.selectedCategoryIDs[2]
        )
          this.lessonsList.push(lesson);
      });
      this.subSubSubSelect = [];
      if (selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubSelect.push(...selectedSubSubCategory.sub_categories);
      }
      this.videosList = [];
    },
    onSelectSubSubSubCategory(e) {
      let title = e;
      let selectedSubSubSubCategory = this.subSubSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.selectedCategoryIDs[3] = selectedSubSubSubCategory.category_id;
      this.lessonsList = [];
      this.getLessons.forEach((lesson) => {
        if (
          lesson.categories[0] == this.selectedCategoryIDs[0] &&
          lesson.categories[1] == this.selectedCategoryIDs[1] &&
          lesson.categories[2] == this.selectedCategoryIDs[2] &&
          lesson.categories[3] == this.selectedCategoryIDs[3]
        )
          this.lessonsList.push(lesson);
      });
    },
    //
    //
    //
    //
    //

    // Select Lessons by Main Grade
    // get Main Categories
    async getMainCategory() {
      this.grades = await this.getCategories;
      // this.grades = await this.getCategories.filter(
      //   (item) => item.main_category === true && item.show_on_register === true
      // );
      this.grades = await this.getCategories.filter(
        (item) => item.main_category === true
      );
    },
    selectLessonsGrade(event) {
      let gradeId = event.target.value;
      this.lessons = this.lessonsList.filter((lesson) =>
        lesson.categories.includes(gradeId)
      );
      console.log(this.lessons);
    },

    async moveStudentsToNewClass(event) {
      // Close Button
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      // Get Ids
      let checkedStudentsID = this.checkedStudents.map(
        (student) => student.student_id
      );

      //------------------------
      // Remove Current
      let StudentsFromClass = {
        classID: this.classId,
        studentsIDs: checkedStudentsID,
      };
      this.removeMultiStudentsFromClass(StudentsFromClass);

      // get Full info of Class
      let classIndex = this.getClasses.findIndex(
        (item) => item.class_id == this.classId
      );
      let ClassesFromStudents = {
        students: checkedStudentsID,
        classes: this.getClasses[classIndex].class_id,
        fullClassesInfo: this.getClasses[classIndex],
      };
      await this.removeMultiClassesFromStudents(ClassesFromStudents);

      // Decrease Current Class
      let decreaseMultiStudentsContent = {
        class_id: this.classId,
        students_count: this.checkedStudents.length,
      };
      this.decreaseMultiStudents(decreaseMultiStudentsContent);

      //------------------------
      // Add New
      // Increace New Class
      let increaseMultiStudentsContent = {
        class_id: this.newClass,
        students_count: this.checkedStudents.length,
      };
      this.increaseMultiStudents(increaseMultiStudentsContent);

      // Add Students To New Class
      let addStudentToNewClassContent = {
        class_id: this.newClass,
        students: checkedStudentsID,
      };
      this.addStudentToNewClass(addStudentToNewClassContent);

      // Add New Class To Students
      let newClassIndex = this.getClasses.findIndex(
        (item) => item.class_id == this.newClass
      );
      let addClassToStudentsContent = {
        students: checkedStudentsID,
        classes: this.getClasses[newClassIndex].class_id,
        fullClassesInfo: this.getClasses[newClassIndex],
      };
      await this.addClassToStudents(addClassToStudentsContent);

      // remove from view
      this.students = this.students.filter(
        (student) => !this.checkedStudents.includes(student)
      );
      closeButton.click();
      this.clearAndShowSuccess("تم نقل الطلاب بنجاح");

      // Clear Selected Students
      this.allSelected = false;
      this.checkedStudents = [];
    },

    async deleteMultiStudentSelect() {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذه الصورة التوضيحية؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الطلاب من الفصل بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          let checkedStudentsID = this.checkedStudents.map(
            (student) => student.student_id
          );

          //------------------------
          // Remove Current
          let StudentsFromClass = {
            classID: this.classId,
            studentsIDs: checkedStudentsID,
          };
          this.removeMultiStudentsFromClass(StudentsFromClass);

          // get Full info of Class
          let classIndex = this.getClasses.findIndex(
            (item) => item.class_id == this.classId
          );
          let ClassesFromStudents = {
            students: checkedStudentsID,
            classes: this.getClasses[classIndex].class_id,
            fullClassesInfo: this.getClasses[classIndex],
          };
          this.removeMultiClassesFromStudents(ClassesFromStudents);

          // Decrease Current Class
          let decreaseMultiStudentsContent = {
            class_id: this.classId,
            students_count: this.checkedStudents.length,
          };
          this.decreaseMultiStudents(decreaseMultiStudentsContent);

          this.students = this.students.filter(
            (student) => !this.checkedStudents.includes(student)
          );
          // Clear Selected Students
          this.allSelected = false;
          this.checkedStudents = [];
        }
      });
    },

    //-------------------------------------
    // Select
    async selectAll() {
      this.checkedStudents = [];
      if (this.allSelected) {
        const selected = this.students.map((student) => student);
        this.checkedStudents.push(...selected);
      } else {
        this.selected = [];
        this.checkedStudents = [];
      }
    },
    updateCheckall() {
      if (this.students.length == this.checkedStudents.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    //-------------------------------------

    getIds() {
      this.studentsIds = this.getSubCollectionIds(this.classId);
    },

    async getClassStudents() {
      this.student = await this.getStudents(this.classId);
    },

    deleteSelectedStudent(student, index) {
      // Delete from Sub Collection Students
      let info = {
        student_id: student.student_id,
        class_id: this.classId,
      };

      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الطالب؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم الحذف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteStudentFromClass(info);
          // Update Student ( Remove Class from Student )
          // Remove class_id from Classes
          student.classes = student.classes.filter(
            (item) => item !== this.classId
          ); // will return ['A', 'C']

          // get class index in fullClassesInfo
          let removeIndex = student.fullClassesInfo
            .map((item) => {
              return item.class_id;
            })
            .indexOf(this.classId);
          // Remove from fullClassesInfo
          student.fullClassesInfo.splice(removeIndex, 1);
          // Update Student
          this.updateStudent(student);
          // decrease Student Count in Class
          this.decreaseCount([this.classId]);
          // Remove From Table
          this.students.splice(index, 1);
        }
      });
    },
    //-----------------
    // Adding Content
    addContentToStudents(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      let payload = {
        studentIDs: this.studentsIds,
        code: this.code,
      };
      if (Object.keys(payload.code.fullInfo).length > 0) {
        this.addContentToStudentsClass(payload);
        this.clearAndShowSuccess("تم اضافة المحتوى لطلاب الفصل");
        closeButton.click();
      }
    },

    addContentToSelectedStudents(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      let checkedStudentsID = this.checkedStudents.map(
        (student) => student.student_id
      );
      let payload = {
        studentIDs: checkedStudentsID,
        code: this.code,
      };
      this.addContentToStudentsClass(payload);
      closeButton.click();
      this.clearAndShowSuccess("تم اضافة المحتوى لطلاب المحدده");
    },

    async getAllLessons() {
      this.lessons = await this.fetchLessons();
    },
    setExpiredDate() {
      let date = new Date();
      date.setDate(date.getDate() + 7);
      this.code.expired_date = date.toISOString().substring(0, 10);
    },
    onSelectLesson(e) {
      this.lessonSelect = this.lessonsList[e];
      // Video
      let videos = this.lessonSelect.contents.filter(
        (content) => content.type == 2
      );
      this.videosList = [...videos];
      // if Not Select Video
      this.code.content_id = this.lessonsList[e].lesson_id;
      this.code.fullInfo = this.lessonsList[e];
    },
    onSelectContent(e) {
      this.code.content_id = this.videosList[e].id;
      this.code.fullInfo = this.videosList[e];
    },

    // Default Functions
    // Clear Input and Messages me Success
    clearAndShowSuccess(message) {
      this.successAdd(message);
      this.clearData();
    },
    // Toast Seccuss Message
    successAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // Clear Data
    clearData() {
      this.code = {
        content_id: "",
        number_of_views: 3,
        expired_date: "",
        fullInfo: {},
      };
      this.selectedCategoryIDs = [];
      this.subSelect = [];
      this.subSubSelect = [];
      document.getElementById("mainCate").value = 0;
      this.setExpiredDate();
    },
  },
  async created() {
    this.getIds();
    await this.getClassStudents();

    // Adding Content
    await this.getAllLessons();
    this.setExpiredDate();
    this.getMainCategory();
    this.Maincategories = this.getCategories.filter(
      (item) => item.main_category === true
    );
  },
  computed: {
    ...mapGetters("classesModule", [
      "getClasses",
      "getStudentsOfClass",
      "getStudentIds",
      "isLoading",
    ]),
    ...mapGetters("lessonsModule", ["getLessons"]),
    ...mapGetters("categoriesModule", ["getCategories"]),
  },
  mounted() {
    this.classes = this.getClasses;
    this.studentsIds = this.getStudentIds;
    this.students = this.getStudentsOfClass;
    this.isloading = this.isLoading;
    this.lessonsList = this.getLessons;
    this.categories = this.getCategories;
  },
  watch: {
    getClasses() {
      this.classes = this.getClasses;
    },
    getStudentIds() {
      this.studentsIds = this.getStudentIds;
    },
    getLessons() {
      this.lessonsList = this.getLessons;
    },

    getStudentsOfClass() {
      this.students = this.getStudentsOfClass;
    },
    getCategories() {
      this.categories = this.getCategories;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
  },
};
</script>

<style></style>
